import { all } from "redux-saga/effects";

import Application from "./ApplicationlistSaga";
import Auth from "./Auth";
import ApplicationDetail from "./ApplicationdetailSaga";
import UserListSaga from "../../views/app-views/usermanage/redux/sagas/UserManageSaga";
import UserCreateSaga from "../../views/app-views/usermanage/redux/sagas/UserCreateSaga";
import BranchSaga from "../../views/app-views/masterdata/redux/sagas/BranchSaga";
import DepoSaga from "../../views/app-views/masterdata/redux/sagas/DepoSaga";
import ComplainlistSaga from "./ComplainlistSaga";
import LockedListSaga from "./lockedlistSaga";

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    Application(),
    ApplicationDetail(),
    UserListSaga(),
    UserCreateSaga(),
    BranchSaga(),
    DepoSaga(),
    ComplainlistSaga(),
    LockedListSaga(),
  ]);
}
